import React, {useEffect, useRef, useState, useImperativeHandle, lazy} from "react";
import GenerateClassName from "../../utils/GenerateClassName";

const AutosizeInput = lazy(() => import("../../utils/AutosizeInput"));

// import "./Select.scss";
import translations from "../../translations/index";

const Select = React.forwardRef((props, ref) => {
    const {
        name = "tms-select",
        options = [],
        preSelectedValues = false,
        label = false,
        change,
        handleFilterReset = () => {
        },
        suffix,
        hideResetButton = false,
        maxValues = 3,
        hideSearchInput = false,
        showLabel = props.showLabel || false,
        defaultValue = 0,
        classname = "tms-select",
        append,
        handleFocusClass: focusClass = () => {
        },
        removeClasses = () => {
        },
        required = false,
        multiple = false,
        prepend,
        disableDefaultClasses = false,
    } = props;

    const configName = "myTalentionConfig";
    const config = window[configName] || {};
    const translation = translations[config.lang] ? translations[config.lang] : translations["de"];
    const dropdownRef = useRef(null);
    const selectSearchRef = useRef(null);
    const refInput = useRef(null);
    const inputRef = useRef(null);
    const firstRender = useRef(true);
    const [isComponentVisible, setIsComponentVisible] = useState(false);
    const [hiddenSelectedValuesAreExpanded, setHiddenSelectedValuesAreExpanded] = useState(false);
    const [values, setValues] = useState([]);
    const [maxValue, setMaxValue] = useState(maxValues);
    const [listValues, setListValues] = useState([]);
    const [filterValues, setFilterValues] = useState([]);
    const [filterValue, setFilterValue] = useState("");
    const [highlightedItem, setHighlightedItem] = useState(0);

    const [selectedValues, setSelectedValues] = useState(() => {
        let preSelectedValuesOutput = [];
        if (props.preSelectedValues) {
            if (Array.isArray(props.preSelectedValues)) {
                props.preSelectedValues.forEach(preSelectedValue => preSelectedValuesOutput.push({
                    label: preSelectedValue,
                    value: preSelectedValue,
                    isprefilter: true
                }));
            } else {
                for (let key in props.preSelectedValues) {
                    const newList = listValues.filter((item) => item.value !== key);
                    preSelectedValuesOutput.push({
                        label: props.preSelectedValues[key],
                        value: key,
                        isprefilter: true,
                    });
                }

            }
        }
        return preSelectedValuesOutput.sort();

    });
    useImperativeHandle(ref, () => ({
        resetDropdownValues,
        resetDropdown,
        clearDropdown,
        handleRemove,
        values,
        setSelectedValues,
    }));
    useEffect(() => {
        if (!firstRender.current && change !== undefined) {
            change(selectedValues);
        } else {

            if (translations[config.lang] === undefined) {
                console.warn(`Could not find language string ${config.lang}. Falling back to german`);
            }

            firstRender.current = false;
        }
        if (multiple === false) {

            /**
             *  no need for selecting multiple times
             *  TODO: disable with flag
             * **/
            closeMenu();
        }
        if (selectedValues.length <= maxValue) {
            setHiddenSelectedValuesAreExpanded(false);
        }
    }, [selectedValues]);

    useEffect(() => {

        console.log(dropdownRef);
        if (firstRender) {
            dropdownRef.current.querySelector(".tms-filter--select").style = "display:none; visibility:hidden;";
            initDropdownValues();
            firstRender.current = false;
        }
    }, []);


    useEffect(() => {
        let preSelectedValuesOutput = [];
        if (props.preSelectedValues) {
            if (Array.isArray(props.preSelectedValues)) {
                props.preSelectedValues.forEach(preSelectedValue => preSelectedValuesOutput.push({
                    label: preSelectedValue,
                    value: preSelectedValue,
                    isprefilter: true
                }));
            } else {
                for (let key in props.preSelectedValues) {
                    const newList = listValues.filter((item) => item.value !== key);
                    preSelectedValuesOutput.push({
                        label: props.preSelectedValues[key],
                        value: key,
                        isprefilter: true,
                    });
                }

            }
        }

    }, [props.preSelectedValues]);

    useEffect(() => {
        if (isComponentVisible && document.querySelector(".tms-select-replacement-search .tms-is-highlighted") !== null) {
            console.log(document.querySelector(".tms-select-replacement-search .tms-is-highlighted button").focus());
            document.querySelector(".tms-select-replacement-search .tms-is-highlighted")
                .scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "start"
                });
        }
    }, [highlightedItem]);

    useEffect(() => {
        if (highlightedItem !== 0 && filterValues.length) {
            setHighlightedItem(0);
        }
    }, [filterValue]);

    useEffect(() => {

        if (isComponentVisible) {
            window.addEventListener("keydown", handleKeys);
            window.addEventListener("blur", closeMenu);

        } else {
            window.removeEventListener("keydown", handleKeys);
            window.removeEventListener("blur", closeMenu);

        }
        return () => {
            window.removeEventListener("keydown", handleKeys);
            window.removeEventListener("blur", closeMenu);
        };

    }, [values, isComponentVisible, highlightedItem, filterValue, listValues, selectedValues]);

    const handleFocusClass = () => {
        focusClass();
        toggleMenu();
    };
    const toggleHover = (key) => {

        setHighlightedItem(key);
    };
    const handleHiddenSelectedValues = () => {
        if (hiddenSelectedValuesAreExpanded) {
            return <span onClick={toggleAllSelectedValues}
                         className={["tms-select-replacement-item", "tms-select-replacement-item-less"].join(" ")}>{translation.showLess}</span>;
        }
        if ((selectedValues.length) - maxValue >= 1) {

            return <span onClick={toggleAllSelectedValues}
                         className={["tms-select-replacement-item", "tms-select-replacement-item-more"].join(" ")}>+{(selectedValues.length) - maxValue} {translation.more}</span>;

        }
        return null;
    };
    const onlyUnique = (value, index, array) => {
        return array.indexOf(value) === index;
    };
    const combineUnique = (newlist, prefilter) => {
        let tempList = [...newlist, ...prefilter];

        // for (let (prop, key) in tempList) {
        //     if (prefilter.some(element => element.value === tempList[prop].value)) {
        //         console.log(key);
        //     }
        // }

        for (let i = 0; i < Object.keys(tempList).length; i++) {
            if (prefilter.some(element => element.value === tempList[i].value)) {
                tempList.splice(i, 1);
            }
        }

        return tempList;

    };
    const handleRemove = (value) => {
        let newList = selectedValues.filter((item) => item.value !== value.value);

        let preSelectedValuesOutput = [];

        if (config.keepJobPrefilter) {
            if (preSelectedValues) {
                if (Array.isArray(preSelectedValues)) {
                    preSelectedValues.forEach(preSelectedValue => preSelectedValuesOutput.push({
                        label: preSelectedValue,
                        value: preSelectedValue,
                        isprefilter: true,
                    }));
                } else {
                    for (let key in preSelectedValues) {
                        newList = listValues.filter((item) => item.value !== key);
                        preSelectedValuesOutput.push({
                            label: preSelectedValues[key],
                            value: key,
                            isprefilter: true,

                        });
                    }

                }
            }
        }
        const index = preSelectedValuesOutput.map((prevalue) => {
            return prevalue.value;
        }).indexOf(value.value);
        const obj = [value, ...listValues];
        let uniqueObjArray = [...new Map(obj.map((item) => [item["value"], item])).values()];

        uniqueObjArray.sort((a, b) => {

            // we do not want to order number
            // if (isNaN(a.label) && isNaN(b.label)) {
            return a.label.localeCompare(b.label);
            // }
        });


        let output = newList;

        if (index === -1) {
            output = combineUnique(newList, preSelectedValuesOutput.sort());
            setSelectedValues(output);
            setValues(uniqueObjArray);
            setListValues(uniqueObjArray);
        }

    };
    const handleAdd = (value) => {

        // console.log("selectedValues=>", selectedValues);
        // console.log("listValues=>", listValues);
        // console.log("values=>", values);

        if (multiple) {
            const newSelected = values.filter((item) => item.value !== value.value);
            setValues(newSelected);
            setListValues(listValues.filter((item) => item.value !== value.value));
            setSelectedValues(selectedValues => [value, ...selectedValues]);
        } else {

            // const newSelected = values.filter((item) => item.value !== value.value);
            // setValues([...newSelected,value])
            // setListValues(values.filter((item) => item.value !== value.value))
            setSelectedValues([value]);
        }

    };
    const isHighLighted = (key) => {
        return highlightedItem === key;
    };
    const handleArrowMovement = (direction, event = false) => {
        if (filterValues.length === 0) {
            return false;
        }
        if (direction === "up") { // up

            if (highlightedItem === 0) { // end of list
                return false;
            }

            setHighlightedItem(item => item - 1);
            // document.querySelector(".tms-select-replacement-search .tms-is-highlighted + li")
            //     .scrollIntoView({
            //         block: "nearest",
            //     });
        }

        if (direction === "down") { // up

            if (highlightedItem === filterValues.length - 1) { // end of list // -1 cause index starts with 0

                return false;

            }

            setHighlightedItem(item => item + 1);

        }

    };
    const removeObjects = (obj1, obj2) => {
        // Konvertieren von obj2 in ein Set für schnellere Suche
        const setToRemove = new Set(Object.keys(obj2));

        // Durchlaufen von obj1
        for (const key in obj1) {
            // Wenn der Schlüssel in setToRemove enthalten ist, lösche die Eigenschaft
            if (setToRemove.has(key)) {
                delete obj1[key];
            }
        }

        // Rückgabe des geänderten Objekts
        return obj1;
    };
    const clearDropdown = () => {

        firstRender.current = true;
        resetDropdownValues();
        let preSelectedValuesOutput = [];

        if (config.keepJobPrefilter) {
            if (preSelectedValues) {
                if (Array.isArray(preSelectedValues)) {
                    preSelectedValues.forEach(preSelectedValue => preSelectedValuesOutput.push({
                        label: preSelectedValue,
                        value: preSelectedValue,
                        isprefilter: true
                    }));
                } else {
                    for (let key in preSelectedValues) {
                        let newList = listValues.filter((item) => item.value !== key);
                        preSelectedValuesOutput.push({
                            label: preSelectedValues[key],
                            value: key
                        });
                    }

                }
            }
            preSelectedValuesOutput.sort();
        }
        setSelectedValues(preSelectedValuesOutput);

        const obj = [...listValues, ...selectedValues];
        let uniqueObjArray = [...new Map(obj.map((item) => [item?.value, item])).values()];

        uniqueObjArray.sort((a, b) => {
            // we do not want to order number
            if (isNaN(a.label) && isNaN(b.label)) {
                return a.label.localeCompare(b.label);
            }
        });

        uniqueObjArray.map(function (item) {
            for (let i = 0; i < preSelectedValuesOutput.length; i++) {
                if (preSelectedValuesOutput[i].value === item.value) {
                    uniqueObjArray.splice(i, 1);
                }
            }
        });
        setListValues(uniqueObjArray);

    };
    const resetDropdown = () => {
        clearDropdown();
        change([]);
    };
    const handleHideDropdown = (event) => {
        if (event.key === "Escape") {
            closeMenu();
        }
        if (event.key === "Tab") {
            closeMenu();
        }

        /** TAB **/
        // if (event.key === "Tab") {
        //     closeMenu();
        // }
    };
    const handleKeys = (event) => {

        if (event.keyCode === 38) {
            handleArrowMovement("up", event.target);
            event.preventDefault();

        }
        if (event.keyCode === 40) {
            handleArrowMovement("down", event.target);
            event.preventDefault();

        }

        if (event.key === "Enter") {

            const filtered = listValues.filter(listValue => listValue.value.toLowerCase()
                .indexOf(filterValue.toLowerCase()) !== -1);

            if (filtered[highlightedItem] !== undefined && filtered.length) {
                handleAdd(filtered[highlightedItem]);

                if (highlightedItem !== 0) {
                    setHighlightedItem(highlightedItem - 1);
                } else {
                    setHighlightedItem(0);

                }

            }
            event.preventDefault();

        }

    };
    const handleClickOutside = event => {

        if (dropdownRef.current !== null) {
            if (dropdownRef.current.contains(event.target) || event.target.classList.contains("tms-select-replacement-item") || event.target.classList.contains("tms-select-replacement-item-li")) {
                return;
            }
            if (event.target.classList.contains("tms-select-replacement-input")) {
                closeMenu();

            }

            closeMenu();
        }

    };
    const initDropdownValues = (mode) => {

        // mode is used to check if we are in a

        let optionsValues = [];

        // we have options at our component

        if (props.options !== undefined) {

            const keys = Object.keys(props.options);

            if (Array.isArray(props.options)) {
                keys.forEach((key, index) => {
                    optionsValues.push({
                        label: props.options[key].toString(),
                        value: props.options[key].toString(),
                    });
                });
            } else {
                keys.forEach((key, index) => {
                    optionsValues.push({
                        label: props.options[key].toString(),
                        value: key.toString()
                    });
                });
            }

            optionsValues.sort((a, b) => {
                // we do not want to order number
                if (isNaN(a.label) && isNaN(b.label)) {
                    return a.label.localeCompare(b.label);
                }
            });
            if (props.keepOptions) {
                setValues(optionsValues);
                setListValues(optionsValues);

                return;
            }


            const newList = optionsValues.filter(value => {
                let found = false;
                for (const preSelectedValue in preSelectedValues) {
                    if (preSelectedValues[preSelectedValue] === value.value) {
                        found = true;
                    }
                }
                return !found;
            });

            setValues(optionsValues);
            setListValues(newList);
        }

    };
    const resetDropdownValues = () => {

        // console.log("resetDropdownValues");
        // mode is used to check if we are in a ?????? in a what?!
        let optionsValues = [];
        const keys = Object.keys(props.options);
        if (Array.isArray(props.options)) {

            keys.forEach((key, index) => {
                optionsValues.push({
                    label: props.options[key].toString(),
                    value: props.options[key].toString()
                });
            });
        } else {
            keys.forEach((key, index) => {
                optionsValues.push({
                    label: props.options[key].toString(),
                    value: key.toString()
                });
            });
        }

        setValues(optionsValues);
        setListValues(optionsValues);
        setHiddenSelectedValuesAreExpanded(false);
        initDropdownValues();

    };
    const showMenu = (e) => {
        if (!hideSearchInput) {
            inputRef.current.focus();
        }
        document.addEventListener("keydown", handleHideDropdown, false);
        document.addEventListener("click", handleClickOutside, false);
        if (!isComponentVisible) {
            setIsComponentVisible(true);
        }

    };
    const resetInput = () => {
        if (multiple && !hideSearchInput) {
            inputRef.current.value = "";
            inputRef.current.style = "width:2px;box-sizing:content-box; display:inline";
            // Create a new 'change' event
            const event = new Event("change", {bubbles: true});
            dropdownRef.current.querySelector("input")
                .dispatchEvent(event);
        }

    };
    const closeMenu = () => {

        document.removeEventListener("keydown", handleHideDropdown);
        document.removeEventListener("click", handleClickOutside);
        if (!hideSearchInput) {
            inputRef.current.blur();
        }
        setFilterValue("");
        resetInput();
        removeClasses();
        setIsComponentVisible(false);

    };

    const toggleMenu = (a, b) => {
        showMenu();
    };

    const handleInput = (event) => {

        const newFilterValue = event.target.value;
        setFilterValue(newFilterValue);
    };
    const generateListValues = () => {
        const filtered = listValues.filter(listValue => listValue.value.toLowerCase()
            .indexOf(filterValue.toLowerCase()) !== -1);

        if (JSON.stringify(filterValues) !== JSON.stringify(filtered)) {
            setFilterValues(filtered);
        }

        // const filteredSort = filtered.sort((a, b) => {
        //     return a.label.localeCompare(b.label);
        // }
        // );
        if (filtered.length) {
            return filtered.map((filteredItem, key) => {
                const {label} = filteredItem;
                return <li
                    onMouseEnter={() => {
                        toggleHover(key);
                    }}
                    onFocus={() => {
                        toggleHover(key);
                    }}
                    aria-label={label}
                    className={`${multiple && selectedValues.length && selectedValues !== undefined ? "" : selectedValues[0]?.label === label.toString() ? "tms-is-selected" : ""} tms-select-replacement-item-li tms-select-replacement-item-li--${GenerateClassName(label)} ${isHighLighted(key) ? "tms-is-highlighted" : ""}`}
                    onClick={(e) => {
                        handleAdd(filteredItem);
                    }} key={key}>
                    <button type="button"
                        aria-label={`${label} ${suffix ? suffix : ""} - ${key}/${filtered.length}`}
                    >{label}{suffix}</button>
                </li>;

            });
        }
        return <li key={-1}>{translation.infoNoHits}</li>;
    };

    const toggleAllSelectedValues = () => {
        setHiddenSelectedValuesAreExpanded((old) => !old);
    };
    const removeValueWithBackspace = (event) => {

        /** Remove values from a multiple select field with backspace **/

        /** No Backspace? No Service **/

        if (event.key !== "Backspace") {
            return false;

        }

        /**
         * We get the current value to check if it is empty,
         * just then remove elemente from the selected elements
         * **/

        const inputValue = event.target.value;

        if (inputValue) {
            return false;
        }
        if (selectedValues.length) {
            // if selected jobs is longer than the max value from the option

            if (selectedValues.length >= maxValue && hiddenSelectedValuesAreExpanded) {
                handleRemove(selectedValues[selectedValues.length - 1]);
                return true;
            }

            if (selectedValues.length <= maxValue && hiddenSelectedValuesAreExpanded === false) {
                handleRemove(selectedValues[selectedValues.length - 1]);
                return true;
            }
            handleRemove(selectedValues[maxValue - 1]); // minus 1 cause index starts with zero

        }

    };

    const classNames = disableDefaultClasses ? [].concat(classname) : ["tms-filter", "tms-filter--select", `tms-filter--${name}`].concat(classname);
    let optionValues;
    if (Array.isArray(options)) {
        optionValues = options.map((item, key) => {
            return (<option key={key} value={item}>
                {prepend} {item} {append}
            </option>);
        });
    } else {
        optionValues = Object.keys(options)
            .map((key) => {
                return (<option key={key} value={key}>
                    {prepend} {options[key]} {append}
                </option>);
            });
    }
    return (<div ref={dropdownRef} onClick={(event) => {
        toggleMenu(event, 123);
    }}
                 className={["tms-select-replacement-wrapper", props.required ? "tms-is-required" : ""].join(" ")}>

        <label className={"tms-select-replacement-label"} htmlFor={`tms-select--${name}`}
               aria-labelledby={`tms-select--${name}`} id={`tms-label--${name}`}>{label} {required ? "" :
            <span className={"tms-is-optional"}>{translation.optional}</span>}</label>
        <select
            name={name}
            tabIndex={-1}
            aria-disabled={true}
            multiple={multiple}
            data-tms-name={name}
            id={`tms-select--${name}`}
            required={required}
            className={classNames.join(" ")}
            defaultValue={multiple ? [defaultValue] : defaultValue}
        >
            {optionValues}
        </select>
        <div
            className={["tms-select-replacement", isComponentVisible ? "tms-select-replacement-is-active" : ""].join(" ")}>
            <div className={["tms-select-replacement-input"].join(" ")}
                 ref={refInput}>{selectedValues.map((item, key) => {
                if (!hiddenSelectedValuesAreExpanded && key >= maxValue) {
                    return null;
                }
                return <span
                    className={`tms-select-replacement-item--${GenerateClassName(item.label)} tms-select-replacement-item ${item.isprefilter ? "tms-is-prefilter" : ""}`}
                    onClick={multiple ? () => {
                        // return multiple ? handleRemove(item) : false;
                        handleRemove(item);
                    } : null}
                    key={item.label}>{item.label}{suffix} {!hideResetButton && multiple && (
                    <span><svg
                        className={["tms-select-replacement-item-icon", item.length ? key : key].join(" ")}
                        height="14" width="14"
                        viewBox="0 0 20 20" aria-hidden="true"
                        focusable="false"
                    ><path
                        d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"/></svg></span>)}</span>;

            })}
                {!isComponentVisible && selectedValues.length === 0 && filterValue.length === 0 ? (
                    <span
                        className={"tms-select-replacement-placeholder"}>{translation.pleaseChoose}</span>) : null}
                {!hideSearchInput && (<AutosizeInput name={name}
                                                     onChange={handleInput}
                                                     type={props.isInFocus ? "text" : "text"}
                                                     isInFocus={props.isInFocus}
                                                     aria-label={label}
                                                     handleFocusClass={handleFocusClass}
                                                     onKeyDown={removeValueWithBackspace}
                                                     value={filterValue}
                                                     ref={inputRef}/>)}

                {handleHiddenSelectedValues()}
                {multiple ? <span
                    className={"tms-multiple-allowed"}> {multiple ? translation.multipleSelectionPossible : ""}</span> : null}
                {/*{(showPlaceholder && !selectedValues.length > 0) && (*/}
                {/*    <div className={"tms-select-replacement-placeholder"}>{label}</div>)}*/}

            </div>
            <div className={"tms-select-replacement-actions"}>
                {(!hideResetButton && multiple && selectedValues.length > 0) && (
                    <div onClick={() => {
                        resetDropdown();
                    }} className="tms-reset-button">

                        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true"
                             focusable="false"
                        >
                            <path
                                d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"/>
                        </svg>
                    </div>)}
                {/*{selectedValues.length > 0 && <span className={"tms-separator"}></span>}*/}
                <div className={"tms-open-button"}>
                    <svg height="20" width="20" viewBox="0 0 20 20"
                         aria-hidden="true" focusable="false"
                    >
                        <path
                            d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"/>
                    </svg>
                </div>
            </div>

        </div>
        {isComponentVisible && (<div ref={selectSearchRef} className={["tms-select-replacement-search"].join(" ")}>
            <ul>
                {generateListValues()}
            </ul>
        </div>)}
    </div>);
});

export default Select;
